import { NgModule } from '@angular/core';
import { ElementCardsDirective } from './element-cards.directive';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ ElementCardsDirective ],
    exports: [ ElementCardsDirective ],
})
export class ElementCardsDirectiveModule {}
